import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faUser, faBuilding, faExclamationTriangle, faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';

export interface SaveConfigurationModalData {
  tabName: string;
  currentAudience: 'USER' | 'CUSTOMER';
  currentAudienceName: string;
  userName: string;
  customerName: string;
  isFromPortalConfig: boolean;
}

@Component({
  selector: 'app-save-configuration-modal',
  templateUrl: './save-configuration-modal.component.html',
  styleUrls: ['./save-configuration-modal.component.scss']
})
export class SaveConfigurationModalComponent implements OnInit {
  // Icons
  faUser = faUser;
  faBuilding = faBuilding;
  faExclamationTriangle = faExclamationTriangle;
  faTimes = faTimes;
  faCheck = faCheck;

  // Audience selezionata per il salvataggio
  selectedAudience: 'USER' | 'CUSTOMER' = 'USER';

  constructor(
    public dialogRef: MatDialogRef<SaveConfigurationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SaveConfigurationModalData
  ) {
    // Imposta l'audience corrente come default
    this.selectedAudience = data.isFromPortalConfig ? 'CUSTOMER' : 'USER';
  }

  ngOnInit(): void {}

  /**
   * Chiude la modale senza salvare
   */
  close(): void {
    this.dialogRef.close(null);
  }

  /**
   * Conferma il salvataggio con l'audience selezionata
   */
  confirmSave(): void {
    this.dialogRef.close(this.selectedAudience);
  }

  /**
   * Restituisce il messaggio di warning in base all'audience selezionata
   */
  getWarningMessage(): string {
    return this.selectedAudience === 'USER'
      ? 'saveConfigModal.userWarning'
      : 'saveConfigModal.customerWarning';
  }
}
